module.exports = __webpack_public_path__ + "static/select-game-5f69762ec5e48f15f1bc092da2a0c96d.jpg";